export const Required = () => {
  return (
    <p className="flex h-fit rounded-[2px] border border-[#F7D4D6] bg-[#FDF4F5] px-1 text-xs font-medium text-[#DC0000]">
      必須
    </p>
  );
};
